import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import { loadBlogList } from "@/lib/seo/blogList";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/zh-cn/blog/")({
  loader: () => loadBlogList("zh-cn"),
  head: () => buildRouteHead("/zh-cn/blog", {
      title: "生命科学博客 — 洞察与更新 | QbD Group",
      description: "关注 QbD Group 的最新法规洞察、行业动态与专家观点，涵盖制药、生物技术、医疗器械与 IVD 领域。",
    }),
  component: Blog,
});

